<template>
    <v-container fluid style="max-width: 500px;" v-show="isLoading">
        <v-layout
                text-center
                wrap
        >
            <v-flex xs12>
                <v-img
                        :src="require('../assets/logo.png')"
                        class="my-6"
                        contain
                        alt="Ayalon Routes Logo"
                        height="200"
                ></v-img>
            </v-flex>

            <v-flex mb-4>
                <v-card class="elevation-1">
                    <v-card-text>
                        <v-form ref="form">
                            <v-text-field
                                    v-model="userInfo.governmentId"
                                    :label="$t('governmentId')"
                                    :rules="governmentIdRules"
                                    name="GovernmentId"
                                    id="governmentId"
                                    type="number"
                                    v-on:keydown.enter='onEnterClick'
                            ></v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions ><div class="text-right">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="submit" id="login">{{$t('login')}}</v-btn>
                    </div>
                    </v-card-actions>
                    <v-bottom-sheet v-model="sheet">

                        <alert-msg :data="alertMessage" />
                    </v-bottom-sheet>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import querystring from 'querystring'

    import config from "../ayalconfig";
    import offlineStorage from "@/dbService";
    import Vuex from "vuex";
    const alertMsg = () => import("./AlertMessage");

    export default {
        components: {
            alertMsg
        },
        data: () => ({
            governmentIdRules: [
                v => !!v || 'דרוש מזהה ממשלתי',
                v => /(^[0-9]{9}$)/.test(v) || 'אורך יכול להיות 9 בלבד',
            ],
            alertMessage:'',
            sheet: false,
            isLoading:false,
        }),
      created() {
        this.isExcludeGovId()
      },
        computed:{
            userInfo() {
                return this.$store.getters.userInfo;
            }
        },
        methods: {

            submit() {
                if(!this.validateInputs()){
                    return
                }
                Vuex.Store.surveyFromLoginProcess = true
                this.$logger.debug("Screen: Login");
                this.$service.navigateTo('StartSurvey');
            },

            validateInputs(){
                if (!this.userInfo.governmentId || !this.$refs.form.validate()) {
                    const alertMessage = this.$t("governmentId.required");
                    this.alert(alertMessage);
                    return false;
                }
                return true;
            },

            onEnterClick(e){
                e.preventDefault();
                this.submit();
            },

            alert(message) {
                this.alertMessage = message;
                this.sheet = true
            },
          isExcludeGovId() {
            let endpoint = config.user.excludeGovId;
            let defaultGovId = config.user.defaultGovId
            let self = this;
            let surveyNumber = Vuex.Store.surveyNumber;
            this.callApi(endpoint, "POST", {surveyNumber:surveyNumber}).then((response)=>{
              if (response.data.success){
                self.userInfo.governmentId = defaultGovId
                self.userInfo.enteredDate = new Date();
                let params = {id:response.data.surveyNumber}
                self.$service.navigateTo("Survey", params);
              }else {
                self.isLoading = true
              }
            }).catch(function (e) {
              self.isLoading = true;
            });
          },
          callApi: function (url, method, params) {
            method = method || 'post';
            return axios({
              method: method,
              url: url,
              data: params
            })
          },
        }
    };
</script>
